import React from 'react';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Pagination } from '@facet-wealth/design';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';

const useStyles = buildUseStyles('ThreadListPagination', (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(0.5, 0),
  },
}));

const ThreadListPagination = () => {
  const { logEvent } = useEventTrackingLogEvent({ nodeName: 'Thread List Pagination' });
  const { displayInfo } = useSnackbarContext();

  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    threadsHasNextPage,
    loadThreadsCollectionNextPage,
    loadThreadsCollectionPreviousPage,
    isThreadsPageLoading,
    threadsCollectionPage,
    isSearching,
  } = useMessagesContext();


  const handlePaginationClick = (event, page) => {
    if (isSearching) {
      displayInfo('You may not use pagination while searching is in progress ', { timeout: 3000 });
      logEvent('Pagination attempted while searching', {});
      return;
    }

    if (page > threadsCollectionPage) {
      loadThreadsCollectionNextPage();
    } else if (page < threadsCollectionPage) {
      loadThreadsCollectionPreviousPage();
    }
  };

  return (
    <Box className={classNames(classes.root)}>
      <Pagination
        page={threadsCollectionPage}
        onChange={(event, page) => handlePaginationClick(event, page)}
        hasNextPage={threadsHasNextPage}
        loading={isThreadsPageLoading}
      />
    </Box>
  );
};

ThreadListPagination.defaultProps = {
};

ThreadListPagination.propTypes = {
};

export { ThreadListPagination };
